import { setCookie } from '@elab/core/utils/cookie';
import { application } from '@elab/core/utils/appData';

export const getNotifyMeListRedirectURL = () => {
    const redirectURL = new URL('/my-account/notification', window.location.origin);
    return redirectURL.toString();
};

export const setNotifyProductCookie = productCode => {
    setCookie(`${application.baseSiteId}-my-account/notification`, productCode, 1);
};
